
import homeQuery from "@/apollo/queries/pages/home.gql";
import lenisScrollMixin from '@/mixins/lenisScrollMixin';
import previewModeMixin from '@/mixins/previewModeMixin';
import seoMixin from '@/mixins/seoMixin';
import { retryApolloQuery } from "~/utils/retryApolloQuery";

export default {
  name: 'index',
  colorMode: 'light',
  mixins: [lenisScrollMixin, previewModeMixin, seoMixin],
  data() {
    return {
      home: null,
    };
  },
  async asyncData({app, store}) {
    const previewMode = store.state.previewMode;

    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    try {
      const responseHome = await retryApolloQuery(
        app.apolloProvider.defaultClient,
        {
          query: homeQuery,
          variables: {
            locale: app.i18n?.locale || 'en',
          },
        },
        {
          maxAttempts: 5,
          onRetry: (error, attempt) => {
            console.log(`Home page query retry ${attempt}/5`)
          },
          fallbackData: { data: { home: { data: null } } }
        }
      );

      const home = responseHome.data?.home;

      return {
        home,
        previewMode,
      };
    } catch (error) {
      console.error('Error in home page asyncData:', error);
      return { home: null, previewMode };
    }
  },
  methods: {
    getPageData() {
      return this.home?.data;
    },
  },
}
